import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import FAQAccordion from "../components/sections/FAQAccordion";
import { Reveal } from "../components/Reveal";
import { useConsultation } from "../context/ConsultationContext";

export default function FAQ() {
  const { openModal } = useConsultation();
  useEffect(() => {
    document.title = "FAQ — JOBLSX";
  }, []);

  return (
    <div>
      <PageHeader
        overline="FAQ"
        title="Frequently asked."
        subtitle="Everything you need to know about consultations, guidance, and getting started with JOBLSX."
      />

      <section className="py-12 md:py-20">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <FAQAccordion />

          <Reveal delay={0.1}>
            <div className="mx-auto mt-16 max-w-3xl rounded-3xl border border-white/10 bg-white/[0.02] p-8 text-center md:p-12">
              <h3 className="font-display text-2xl font-medium tracking-tight">Still have a question?</h3>
              <p className="mt-3 text-slate-400">Book a consultation and we&rsquo;ll answer everything, personally.</p>
              <button
                onClick={openModal}
                className="mx-auto mt-6 flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-4 font-medium text-white shadow-[0_0_24px_rgba(37,99,235,0.4)] transition-all duration-300 hover:bg-blue-700 hover:-translate-y-1"
                data-testid="faq-book-button"
              >
                Book Consultation <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
